export default "__VITE_ASSET__B0KPMsF9__"